export const ERR_CODE = {
  "auth/email-already-in-use": "이미 사용 중인 이메일입니다.",
  "auth/weak-password": "비밀번호는 6글자 이상이어야 합니다.",
  "auth/invalid-email": "잘못된 이메일 형식입니다.",
  "auth/user-not-found": "가입되지 않은 이메일입니다.",
  "auth/wrong-password": "비밀번호가 일치하지 않습니다.",
  "auth/network-request-failed": "네트워크 연결에 실패 하였습니다.",
  "auth/internal-error": "잘못된 요청입니다.",
};
